import { billingErrorMappings } from './billing.errors';
import { customerErrorMappings } from './customer.errors';
import { nfseCertificateErrorMappings } from './nfse-certificate.errors';
import { nfseCompanyErrorMappings } from './nfse-company.errors';
import { nfseCoreErrorMappings } from './nfse-core.errors';
import { nfseLinkErrorMappings } from './nfse-link.errors';
import { nfseServiceValidationErrorMappings } from './nfse-service-validation.errors';
import { nfseValidationErrorMappings } from './nfse-validation.errors';
import { nfseWebhookErrorMappings1 } from './nfse-webhook-1.errors';
import { nfseWebhookErrorMappings2 } from './nfse-webhook-2.errors';
import { nfseWebhookErrorMappings3 } from './nfse-webhook-3.errors';
import { nfseWebhookTaxAuthorityErrorMappings1 } from './nfse-webhook-tax-authority-1.errors';
import { nfseWebhookTaxAuthorityErrorMappings2 } from './nfse-webhook-tax-authority-2.errors';
import { nfseZeztraConfigErrorMappings } from './nfse-zeztra-config.errors';
import { systemErrorMappings } from './system.errors';
export const cobrancaErrorDictionary = {
    IBK: {
        ...customerErrorMappings,
        ...billingErrorMappings,
        ...systemErrorMappings,
        ...nfseCoreErrorMappings,
        ...nfseCertificateErrorMappings,
        ...nfseZeztraConfigErrorMappings,
        ...nfseValidationErrorMappings,
        ...nfseServiceValidationErrorMappings,
        ...nfseWebhookErrorMappings1,
        ...nfseWebhookErrorMappings2,
        ...nfseWebhookErrorMappings3,
        ...nfseWebhookTaxAuthorityErrorMappings1,
        ...nfseWebhookTaxAuthorityErrorMappings2,
        ...nfseLinkErrorMappings,
        ...nfseCompanyErrorMappings,
    },
    DEFAULT: {},
    SUPERAPP: {},
};
